import { AnyAction } from "redux";
import { fulfilled } from "../../../checkout/utils";
import * as AT from "../actionTypes";
import { SelectedAgent } from "../../../../../models/state/retailer";

const selectedAgentReducer = (state: SelectedAgent | null = null, action: AnyAction): SelectedAgent | null => {
    switch (action.type) {
        case fulfilled(AT.RETAILER_UPDATE_SELECTED_AGENT): {
            return action.payload.selectedAgent ?? null;
        }
        default: {
            return state;
        }
    }
};

export default selectedAgentReducer;
